import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';

import InputField from './InputField';

@withI18n
class PasswordField extends React.Component {
  static propTypes = {
    inputRef: PropTypes.func,
  };
  static defaultProps = {};

  state = {show: false};

  @autobind onClickShow(event) {
    event.preventDefault();
    this.setState({show: !this.state.show});
  }

  render() {
    const {i18n} = this.context;
    const {inputRef, ...rest} = this.props;

    const {show} = this.state;

    const type = show ? 'text' : 'password';
    const label = show ? i18n.__('Hide') : i18n.__('Show');

    return (
      <InputField {...rest} type={type} groupClassName="form-group--password" ref={inputRef}>
        <a
          href="#"
          className="js-only password-field-show-button"
          onClick={this.onClickShow}
        >{label}</a>
      </InputField>
    );
  }
}

export default PasswordField;



// WEBPACK FOOTER //
// ./spa/Components/Form/PasswordField.jsx